import { render } from "./gatewayConfigure.vue?vue&type=template&id=c36e7364&scoped=true"
import script from "./gatewayConfigure.vue?vue&type=script&lang=js"
export * from "./gatewayConfigure.vue?vue&type=script&lang=js"

import "./gatewayConfigure.vue?vue&type=style&index=0&id=c36e7364&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c36e7364"]])

export default __exports__